import {
  FETCHING_SHARES_COUNT,
  FETCHING_SHARES_COUNT_SUCCEEDED,
  FETCHING_SHARES_COUNT_FAILED,
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const SHARES_BASE_URL = `${API_URL}/api/1.0/shares`;

/** fetch shares */
export const fetchSharesCount = createAction(FETCHING_SHARES_COUNT);
const fetchingSharesCountSucceeded = createAction(FETCHING_SHARES_COUNT_SUCCEEDED);
const fetchingSharesCountFailed = createAction(FETCHING_SHARES_COUNT_FAILED);

function* fetchSharesCountSaga(action) {
  let { account } = action.payload;

  let url = buildUrl(SHARES_BASE_URL, { path: "/count" });
  const fetchSharesCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account: account },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSharesCountAPI);
    yield put(fetchingSharesCountSucceeded(response));
  } catch (error) {
    yield put(fetchingSharesCountFailed(error));
  }
}

export default function* sharesSaga() {
  yield takeLatest(FETCHING_SHARES_COUNT, fetchSharesCountSaga);
}
